import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhou",
  "use": "icon-zhou-usage",
  "viewBox": "0 0 40 53",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 53\" id=\"icon-zhou\">\r\n  <text id=\"icon-zhou_舟\" transform=\"translate(20 43)\" style=\"font-weight:bold;\" font-size=\"40\" font-family=\"YuGothicUI-Bold, Yu Gothic UI\" font-weight=\"700\"><tspan x=\"-20\" y=\"0\">舟</tspan></text>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol